export function totalAnnotationCount(countsByStyle: Record<string, number>): number {
  return Object.values(countsByStyle).reduce((sum, val) => sum + val, 0);
}

const STYLE_ORDER = ["error", "warning", "info", "success", "default"] as const;

const STYLE_COLORS: Record<string, string> = {
  error: "bg-red-500",
  warning: "bg-orange-500",
  info: "bg-blue-500",
  success: "bg-green-500",
  default: "bg-gray-500",
};

export function AnnotationsBadge({
  countsByStyle,
  className,
}: {
  countsByStyle: Record<string, number>;
  className?: string;
}) {
  const entries = STYLE_ORDER.filter((style) => (countsByStyle[style] ?? 0) > 0).map((style) => ({
    style,
    count: countsByStyle[style],
  }));

  if (entries.length === 0) {
    return null;
  }

  const total = totalAnnotationCount(countsByStyle);
  const label = total === 1 ? "1 annotation" : `${total} annotations`;

  return (
    <span
      data-annotations-badge={true}
      title={label}
      className={`inline-flex items-center -space-x-0.5 ${className || ""}`}
    >
      {entries.map(({ style, count }, index) => (
        <span
          key={style}
          style={{ zIndex: entries.length - index }}
          className={`size-4 rounded-full px-1 text-center text-[9px] font-semibold leading-[16px] tracking-tight text-white ring-1 ring-white ${STYLE_COLORS[style] || STYLE_COLORS.default}`}
        >
          {count}
        </span>
      ))}
    </span>
  );
}
